export default __webpack_public_path__ + "static/media/flyingRock2.72bb12eb.webp";